import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FirmService} from '../services/firm.service';
import {Router} from '@angular/router';
import {SwalComponent} from '@sweetalert2/ngx-sweetalert2';
import {NgxSpinnerService} from 'ngx-spinner';
import {ImageService} from '../services/image.service';

@Component({
    selector: 'app-firms',
    templateUrl: './firms.component.html',
    styleUrls: ['./firms.component.css']
})
export class FirmsComponent implements OnInit {
    @ViewChild('closeCreateModal') closeCreateModal: ElementRef;
    @ViewChild('errorSwal') private errorSwal: SwalComponent;
    @ViewChild('successSwal') private successSwal: SwalComponent;
    public firms = [];
    public nonInstallationFirms = [];
    public firmId;
    public firmDetail = [];
    public isCollaps = false;
    searchText: string;
    emailValidError;

    cropInput: any;
    imageChangedEvent: any = '';
    croppedImage: any = '';
    cropperReady = false;
    constructor(private firmService: FirmService, private router: Router, private spinner: NgxSpinnerService,
                private imageService: ImageService) {
    }

    ngOnInit() {
        this.spinner.show();
        this.getFirmsForSuperAdmin();
        this.getNonInstallationFirms();
    }


    getFirmsForSuperAdmin() {
        this.firmService.getFirmsForSuperAdmin().subscribe(res => {
            console.log(res);
            this.firms = res.dataFirmForSuperAdmin;
            for (const firm of this.firms) {
                if (firm._id.firmId[0]) {
                    this.firmDetail.push(firm._id.firmId[0]);
                }
            }
            console.log(res);
        }, error => {
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
            }
        });
    }

    getNonInstallationFirms() {
        this.firmService.getNonInstallationFirms().subscribe(res => {
            this.nonInstallationFirms = res.dataFirm;
            console.log(res);
            this.spinner.hide();
        }, error => {
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
                this.spinner.hide();
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
                this.spinner.hide();
            }
        });
    }


    setFirmId(id) {
        localStorage.setItem('firmId', id);
    }

    validateEmail(email) {
        this.emailValidError = false;
        const valid = String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
        if (!valid) {
            this.emailValidError = true;
        }
    }

    formControl(data, name) {
        if (data === '' || data === undefined) {
            this.errorSwal.title = 'Lütfen boş alan bırakmayınız! ' + name + ' ';
            this.errorSwal.show();
            return true;
        }
    }


    fileChangeEvent(event: any): void {
        this.cropInput = event.target.files;
        this.imageChangedEvent = event;
    }

    imageCropped(image: string) {
        this.croppedImage = image;
    }

    imageLoaded() {
        this.cropperReady = true;
    }

    imageLoadFailed() {
        this.errorSwal.title = 'Lütfen png yada jpeg resim seçiniz ';
        this.errorSwal.show();
    }


    convertToFile(base64Str: string, fileName: string) {

        const binary = atob(base64Str.split(',')[1]);
        const array = [];
        for (let i = 0; i < binary.length; i++) {
            array.push(binary.charCodeAt(i));
        }
        return new File([new Uint8Array(array)], fileName, {type: 'image/jpeg', lastModified: Date.now()});
    }

    updateFirmImage(firmId) {

        if (this.croppedImage && this.croppedImage !== '') {
            let fileName = this.cropInput[0].name;
            fileName = fileName.split('.');
            const formData = new FormData();
            const ImageFile = this.convertToFile(this.croppedImage.base64,
                fileName[0] + '_' + firmId + '.' + fileName[1]);
            formData.append('upfile', ImageFile);

            this.imageService.addFirmImage(formData, firmId).subscribe((res) => {
                console.log(res);
            });
        }
    }

    createFirm(name, legalName, taxAdm, taxNo, adress, mail, site, phone) {
        if (this.formControl(name, 'Firma Adı')
            || this.formControl(legalName, 'Yasal Ünvan')
            || this.formControl(taxAdm, 'Vergi Dairesi')
            || this.formControl(taxNo, 'Vergi Numarası')
            || this.formControl(adress, 'Adresi')
            || this.formControl(mail, 'Mail Adresi')
            || this.formControl(phone, 'Telefon Numarası')
        ) {
            return;
        }
        this.validateEmail(mail);
        if (this.emailValidError) {
            this.errorSwal.title = 'Geçerli Mail Adresi Giriniz';
            this.errorSwal.show();
            return true;
        }
        this.spinner.show();
        const firm = {
            name: name,
            legalName: legalName,
            taxNo: taxNo,
            address: adress,
            mail: mail,
            webSite: site,
            phone: phone,
            taxAdministration: taxAdm
        };

        this.firmService.createFirm(firm).subscribe(res => {
            this.spinner.show();
            console.log(res);
            this.successSwal.title = 'Başarılı!';
            this.closeCreateModal.nativeElement.click();
            this.getNonInstallationFirms();
            this.spinner.hide();

            if (this.croppedImage) {
                this.updateFirmImage(res._id);
            }
        }, error => {
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
                this.spinner.hide();
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
                this.spinner.hide();
            }
        });

    }

    deleteFirm(_id) {
        this.spinner.show();
        this.firmService.deleteFirm(_id).subscribe(res => {
            console.log(res);
            this.successSwal.title = 'Başarılı!';
            this.successSwal.show();
            this.getNonInstallationFirms();
            this.spinner.hide();
        }, error => {
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
                this.spinner.hide();
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
                this.spinner.hide();
            }
        });

    }

    checkCollapse(status: boolean) {
        this.isCollaps = !status;
        console.log(this.isCollaps);

    }
}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/firms/firms.component.ts